import { action, app, core, imaging } from "photoshop";
import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";

async function onSelectionChanged() {
	if (!app.activeDocument) {
		postToRenderer([
			{
				key: "selectionChanged",
				id: uuidv4(),
				values: {
					base64: "",
				},
			},
		]);
		return;
	}

	const sel = app.activeDocument.selection;
	const bounds = sel?.bounds ?? null;

	await core.executeAsModal(
		async (_executionContext) => {
			const sourceWidth = bounds
				? bounds.right - bounds.left
				: app.activeDocument.width;
			const sourceHeight = bounds
				? bounds.bottom - bounds.top
				: app.activeDocument.height;

			const maxWidth = 512;
			const scale = sourceWidth > maxWidth ? maxWidth / sourceWidth : 1;
			const targetWidth = Math.round(sourceWidth * scale);
			const targetHeight = Math.round(sourceHeight * scale);

			const { imageData } = await imaging.getPixels({
				documentID: app.activeDocument.id,
				applyAlpha: true,
				sourceBounds: bounds
					? {
							left: bounds.left,
							top: bounds.top,
							right: bounds.right,
							bottom: bounds.bottom,
						}
					: {
							left: 0,
							top: 0,
							right: app.activeDocument.width,
							bottom: app.activeDocument.height,
						},

				targetSize: {
					width: targetWidth,
					height: targetHeight,
				},
			});
			const jpegData = await imaging.encodeImageData({
				imageData,
				base64: true,
			});
			const dataUrl = `data:image/jpeg;base64,${jpegData}`;
			postToRenderer([
				{
					key: "selectionChanged",
					id: uuidv4(),
					values: {
						base64: dataUrl,
					},
				},
			]);
		},
		{
			commandName: "Selection Event",
		},
	);
}

const events = [
	"historyStateChanged",
	"select",
	"set",
	"deselect",
	"transform",
	"open",
	"close",
	"make",
];

export function useSelectionEvent() {
	useListenFromRenderer([
		{
			key: "listenSelectionChanged",
			onMessage: async (message) => {
				if (message.values.type === "add") {
					onSelectionChanged();
					action.addNotificationListener(events, onSelectionChanged);
				}
				if (message.values.type === "remove") {
					action.removeNotificationListener(events, onSelectionChanged);
				}
				if (message.values.type === "refresh") {
					onSelectionChanged();
				}
			},
		},
	]);
}
